import styled from 'styled-components';

const Text = styled.div`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: normal;
	line-height: normal;
	user-select: none;
	white-space: pre-line;
`;

export { Text };
